export interface PiRuntimeState {
  isPiBrowser: boolean;
  sdkLoaded: boolean;
  supportsPayments: boolean;
  supportsAuthentication: boolean;
  isSandboxDev: boolean;
  isPiOnlyBuild: boolean; // 🎛️ Absolute compilation flag
}

export const getPiRuntime = (): PiRuntimeState => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      isPiBrowser: false,
      sdkLoaded: false,
      supportsPayments: false,
      supportsAuthentication: false,
      isSandboxDev: false,
      isPiOnlyBuild: false,
    };
  }

  // 🎛️ Read our hard compile-time flag directly from the bundler environment configuration
  const isPiOnlyBuild = String(import.meta.env.VITE_PI_ONLY || "").toLowerCase() === "true";

  // 🔄 Dynamically resolve the presence of the globally injected window script object
  const hasPiObject = typeof (window as any).Pi !== "undefined";
  const isSandboxDev = window.location.search.toLowerCase().includes("platform=pi");
  
  const userAgentLower = navigator.userAgent.toLowerCase();
  const isPiUserAgent = userAgentLower.includes("pibrowser") || userAgentLower.includes("pi-browser");
  const isPiSandboxDomain =
    window.location.hostname.includes("minepi.com") ||
    Boolean(document.referrer?.includes("minepi.com"));

  // 🛡️ Force true if it's a dedicated build branch, otherwise use active container checks
  const isPiBrowser = isPiOnlyBuild || isPiUserAgent || isSandboxDev || isPiSandboxDomain;

  return {
    isPiBrowser,
    sdkLoaded: hasPiObject,
    supportsPayments: hasPiObject && isPiBrowser,
    supportsAuthentication: hasPiObject && isPiBrowser,
    isSandboxDev,
    isPiOnlyBuild,
  };
};

export const isPiEnvironment = (): boolean => getPiRuntime().isPiBrowser;